import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "relative z-10",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
const _hoisted_3 = { class: "flex items-end sm:items-center justify-center min-h-full p-4 text-center lg:p-0" }
const _hoisted_4 = { class: "py-4 px-5 md:px-6 border-b md:flex items-center justify-between" }
const _hoisted_5 = { class: "text-lg md:text-2xl font-medium text-gray-900" }
const _hoisted_6 = {
  key: 0,
  class: "py-4 px-5 md:px-6"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_XIcon = _resolveComponent("XIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: "fixed z-10 inset-0 overflow-y-auto",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closeModal('ModalPreviewDocument')))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all my-8 max-w-4xl w-full",
          onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.file.title), 1),
            _createElementVNode("button", {
              type: "button",
              class: "border border-gray-400 bg-white rounded-md text-gray-500 hover:text-gray-800 focus:outline-none p-2 bg-gray-100 ml-4",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal('ModalPreviewDocument')))
            }, [
              _createVNode(_component_XIcon, { class: "w-5 h-5" })
            ])
          ]),
          (_ctx.timeouted && !_ctx.iframeLoaded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("p", null, [
                  _createTextVNode("Sorry, we can’t preview this file because of size or formatting. Please "),
                  _createElementVNode("a", {
                    class: "text-blue-500",
                    href: _ctx.file.src,
                    target: "_blank",
                    download: ""
                  }, "download", 8, _hoisted_7),
                  _createTextVNode(" it to view the content")
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.file.src.includes('.pdf'))
            ? (_openBlock(), _createElementBlock("iframe", {
                key: 1,
                src: `https://docs.google.com/gview?url=${_ctx.file.src}&embedded=true`,
                style: {"width":"100%","height":"800px","max-height":"80vh"},
                frameborder: "0",
                class: _normalizeClass({'hidden': _ctx.timeouted && !_ctx.iframeLoaded}),
                onLoad: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.iframeLoad && _ctx.iframeLoad(...args)))
              }, null, 42, _hoisted_8))
            : (['.ppt', '.pptx', '.doc', '.docx', '.xls', '.xlsx'].some(r => _ctx.file.src.includes(r)))
              ? (_openBlock(), _createElementBlock("iframe", {
                  key: 2,
                  src: `http://view.officeapps.live.com/op/view.aspx?src=${_ctx.file.src}&embedded=true`,
                  style: {"width":"100%","height":"800px","max-height":"80vh"},
                  frameborder: "0",
                  class: _normalizeClass({'hidden': _ctx.timeouted && !_ctx.iframeLoaded}),
                  onLoad: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.iframeLoad && _ctx.iframeLoad(...args)))
                }, null, 42, _hoisted_9))
              : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}